import listService from 'ListService.js';
import constants   from 'Constants.js';
import TabSettingsView  from 'properties/TabSettingsView.js';
import StyleView        from 'properties/StyleView.js';
import TabAccessView    from 'properties/TabAccessView.js';
import BehaviorView     from 'properties/BehaviorView.js';
import AttributesView   from 'properties/AttributesView.js'
import { pickerCfg } from 'pickerCfg.js';
import notify           from 'NotificationService';

class ViewManagerService {
    constructor() {}


    renderSettingsTab(model,opts){
        if (!listService.propertyTab_Settings) {
            listService.propertyTab_Settings = new TabSettingsView({
                model: model,
                el: $(constants.PROP_SETTNGS_ID)
            });
        } else {
            listService.propertyTab_Settings.model = model;
        }
        listService.propertyTab_Settings.render(opts);
    }

    renderStyleTab(model,opts){
        if (!listService.propertyTab_Style) {
            listService.propertyTab_Style = new StyleView({model: model, el: $(constants.PROP_STYLE_ID)});
        } else {
            listService.propertyTab_Style.model = model;
        }
        listService.propertyTab_Style.render(opts);
    }

    renderAccessTab(model,opts){
        if (!listService.propertyTab_Access) {
            listService.propertyTab_Access = new TabAccessView({
                model: model,
                el: $(constants.PROP_ACCESS_SECTION)
            });
        } else {
            listService.propertyTab_Access.model = model;
        }
        listService.propertyTab_Access.render(opts);
    }

    renderAttributesTab(model,opts){
        if (!listService.propertyTab_Attributes) {
            listService.propertyTab_Attributes = new AttributesView({
                model: model,
                el: $(constants.PROP_ATTRIBUTES_ID)
            });
        } else {
            listService.propertyTab_Attributes.model = model;
        }
        listService.propertyTab_Attributes.render(opts);
    }

    renderBehaviorsTab(model,opts){
        if (!listService.propertyTab_Behaviors) {
            listService.propertyTab_Behaviors = new BehaviorView({model: model, el: $(constants.PROP_BHVR_ID)});
        } else {
            listService.propertyTab_Behaviors.model = model;
        }
        listService.propertyTab_Behaviors.render(opts);
    }


    renderLayoutPropertyTabs(model, opts) {
        try {
            $('#settings-tab a').trigger('click');
            this.renderSettingsTab(model,opts);
            this.renderStyleTab(model,opts);
            this.renderAccessTab(model,opts);
            this.renderAttributesTab(model,opts);
            this.renderBehaviorsTab(model,opts);
            
        } catch (ex) {
            console.log(ex);
            //The message was removed but an error still happens about circular structure to JSON
            //this happens the first time you load the form, add a control to canvas, click on any behavior
            //then click on the Layout icon
            //notify.error('An error has occurred attempting to display properties')
        }
    }

    renderTab(tabName,model,opts){
        try {
            switch (tabName){
                case constants.SETTINGS_TAB:
                    this.renderSettingsTab(model,opts);
                    break;
                case constants.STYLE_TAB:
                    this.renderStyleTab(model,opts);
                    break;
                case constants.ACCESS_TAB:
                    this.renderAccessTab(model,opts);
                    break;
                case constants.ATTRIBUTES_TAB:
                    this.renderAttributesTab(model,opts);
                    break;
                case constants.BEHAVIORS_TAB:
                    this.renderBehaviorsTab(model,opts);
                    break;
            }
        } catch (ex) {
            console.log(ex);
            //notify.error('An error has occurred attempting to display properties')
        }
    }

    clearPropertyViews() {
        if (listService.propertyTab_Settings) {
            listService.propertyTab_Settings.close();
        }

        if (listService.propertyTab_Style) {
            listService.propertyTab_Style.close();
        }

        if (listService.propertyTab_Access) {
            listService.propertyTab_Access.close();
        }

        if (listService.propertyTab_Attributes) {
            listService.propertyTab_Attributes.close();
        }

        if (listService.propertyTab_Behaviors) {
            listService.propertyTab_Behaviors.close();
        }

        listService.propertyTab_Settings = undefined;
        listService.propertyTab_Style = undefined;
        listService.propertyTab_Access = undefined;
        listService.propertyTab_Attributes = undefined;
        listService.propertyTab_Behaviors = undefined;
    }

    deafenMains() {
        listService.mainViews.map( ( view, k ) => {
            view.undelegateEvents();
            view.stopListening();
            if (k === constants.KIND_THUMBLIST) {
                view.remove();
            }
        });
    }

    get thumbnailListView () {
        return listService.getMainView(constants.KIND_THUMBLIST);
    }

    renderToolbarPaneView( view ) {
        if (listService.toolbarPaneView) {
            listService.toolbarPaneView.remove();
        }
        listService.toolbarPaneView = view;
        listService.toolbarPaneView.render();
    }

    clearToolbarPaneView ()  {
        if (listService.toolbarPaneView) {
            listService.toolbarPaneView.remove();
        }
        listService.toolbarPaneView = undefined;
    }

    renderMenuView(view) {
        if (listService.menuView) {
            listService.menuView.remove();
        }
        listService.menuView = view;
        listService.menuView.render();
    }

    clearMenuView() {
        if (listService.menuView) {
            listService.menuView.remove();
        }
        listService.menuView = undefined;
    }

    renderEditorView(view) {
        if (listService.editorView) {
            listService.editorView.remove();
        }
        listService.editorView = view;
        listService.editorView.render();
    }

    clearEditorView() {
        if (listService.editorView) {
            listService.editorView.remove();
        }
        listService.editorView = undefined;
    }

    renderBreadcrumbView(view, isLeftView = false) {
        if (!listService.breadcrumb) {
            listService.breadcrumb = { 
                leftView: undefined,
                rightView: undefined
            };
        }

        if (isLeftView && listService.breadcrumb.leftView) {
            listService.breadcrumb.leftView.remove();
        }
        
        if (!isLeftView && listService.breadcrumb.rightView) {
            listService.breadcrumb.rightView.remove();
        }

        if (isLeftView) {
            listService.breadcrumb.leftView = view;
            listService.breadcrumb.leftView.render();
        }
        else {
            listService.breadcrumb.rightView = view;
            listService.breadcrumb.rightView.render();
        }
    }

    clearBreadcrumbView() {
        if (listService.breadcrumb.leftView) {
            listService.breadcrumb.leftView.remove();
        }

        if (listService.breadcrumb.rightView) {
            listService.breadcrumb.rightView.remove();
        }

        listService.breadcrumb = { 
            leftView: undefined,
            rightView: undefined
        };
    }

    renderPageView(view) {
        if (listService.pageView) {
            listService.pageView.remove();
        }
        listService.pageView = view;
        listService.pageView.render();
    }

    clearPageView() {
        if (listService.pageView) {
            listService.pageView.remove();
        }
        listService.pageView = undefined;
    }

    renderFormView(view) {
        if (listService.currentForm) {
            listService.currentForm.remove();
        }
        listService.currentForm = view;
        listService.currentForm.render();
    }

    clearFormView() {
        if (listService.currentForm) {
            listService.currentForm.remove();
        }
        listService.currentForm = undefined;
    }




}
const viewManagerService = new ViewManagerService();
export default viewManagerService;